<template>
  <CommonNoticeCard
    icon="icondiedai1"
    symbol-icon
    :title="data.name"
    :class="b()"
  >
    <div
      slot="content"
      :class="b('tip')"
    >
      <div v-if="data.tip">
        {{ data.tip }}
      </div>
    </div>
    <template #actions>
      <el-tooltip :content="$t('button.positionView')">
        <el-button
          v-if="showPosition"
          type="plaintext2"
          size="mini"
          icon="zkicon iconicon_dingwei"
          @click.stop="position"
        />
      </el-tooltip>
      <el-button
        type="plaintext2"
        icon="zkicon icondakaixinbiaoqian"
        size="mini"
        @click="toBacklog"
      >
        {{ $t('notice.moveToCurrentBacklog') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import { resolveUrl } from '@zk/framework-vue';
import { findDownComponent } from '@zk/framework-vue';

export default {
  name: 'SprintNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      required: true
    },
    root: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPosition: false
    };
  },
  computed: {
    ...mapGetters('app', ['getProject'])
  },
  created() {
    this.checkShouldShowPosition();
  },
  methods: {
    async toBacklog() {
      const p = this.getProject(this.data.projectId);
      await this.$track.send('project-click', {
        projectId: p.id,
        dataId: p.id,
        dataValue: p.pname,
        eventGroupCode: p.sinkNodeEntity === 'Favorite' ?
          'favorite' : p.recentVisit === 1 ?
            'latest' : 'list'
      });
      const page = window.open(resolveUrl(`${this.$config.VUE_APP_PMS_URL}/backlog/list`));
      if (this.root.$route.name === 'roadmap'){
        setTimeout(() => {
          if (page && !page?.closed) {
            this.$track.send('SprintPlan', {
              source: '路线图-创建迭代卡片'
            }, true);
          }
        }, 5000);
      }
    },
    async checkShouldShowPosition(){
      const routeName = this.root.$route.name;
      if (routeName === 'roadmap'){
        const RoadmapComponentIndex = findDownComponent(this.root, 'RoadmapComponentIndex');
        this.showPosition = await RoadmapComponentIndex?.checkCreateSprintShouldShowPosition(this.data);
      }
      if (routeName === 'gantt'){
        const projectApp = document.querySelector('#micro-app_project #app');
        if (!projectApp) {
          return false;
        }
        const ganttPage = findDownComponent(projectApp.__vue__, 'GanttView');
        this.showPosition = await ganttPage?.checkCreateSprintShouldShowPosition(this.data);
        return;
      }
    },
    position() {
      this.eventBus.$emit('sprint:notice-position', this.data);
    }
  }
};
</script>

<style scoped>

</style>
